/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Preview_Empty_TitleInputs */

const cs_blog_preview_empty_title = /** @type {(inputs: Blog_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte příspěvek`)
};

const en_blog_preview_empty_title = /** @type {(inputs: Blog_Preview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a post`)
};

/**
* | output |
* | --- |
* | "Select a post" |
*
* @param {Blog_Preview_Empty_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_preview_empty_title = /** @type {((inputs?: Blog_Preview_Empty_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Preview_Empty_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_preview_empty_title(inputs)
	return cs_blog_preview_empty_title(inputs)
});